import { render, staticRenderFns } from "./EditSubjectType.vue?vue&type=template&id=bd7dcbc8&scoped=true&lang=true&"
import script from "./EditSubjectType.vue?vue&type=script&lang=js&"
export * from "./EditSubjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7dcbc8",
  null
  
)

export default component.exports